/*
  Add to Cart -> cart drawer.

  The custom product form posts normally, which sends the shopper to /cart and
  out of the buying flow. This intercepts it, adds to cart over the API and
  hands the response to the theme's existing <cart-drawer>, so the drawer opens
  in place. Falls back to the normal form post if anything goes wrong, so the
  add never silently fails.
*/
(function () {
  'use strict';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function errorTarget(form) {
    var btn = form.querySelector('[data-ppdp-atc]');
    return btn ? btn.parentNode : form;
  }

  function showError(form, message) {
    var host = errorTarget(form);
    var box = host.querySelector('.ppdp__cart-error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'ppdp__cart-error';
      box.setAttribute('role', 'alert');
      host.appendChild(box);
    }
    box.textContent = message;
  }

  function clearError(form) {
    var box = errorTarget(form).querySelector('.ppdp__cart-error');
    if (box) box.remove();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.closest('[data-ppdp]')) return;
    if (!form.querySelector('[data-ppdp-atc]')) return;

    var cart = drawer();
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (!cart || !window.fetch) return; // let the browser submit normally

    event.preventDefault();
    clearError(form);

    var btn = form.querySelector('[data-ppdp-atc]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var data = new FormData(form);
    // Ask for the drawer's own sections back in the same request, so it can
    // re-render without a second round trip.
    if (cart.getSectionsToRender) {
      data.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      );
      data.append('sections_url', window.location.pathname);
    }
    if (cart.setActiveElement && btn) cart.setActiveElement(btn);

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        // Shopify returns `status` only when the add failed.
        if (state.status) {
          showError(form, state.description || state.message || 'Could not add to cart.');
          return;
        }
        if (cart.classList) cart.classList.remove('is-empty');
        cart.renderContents(state);
      })
      .catch(function () {
        // Never lose the add: fall back to a normal submit.
        form.submit();
      })
      .then(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  });
})();
